






























import Reflect from "reflect-metadata";
import { Component, Vue, Prop } from "vue-property-decorator";

import { User } from "@/models/User";
import userService from "@/services/UserService";
import messageService from "@/services/MessageService";
import session from "@/services/SessionService";

@Component
export default class DeleteAccountDialog extends Vue {
  static DELETE_SUCCESSFUL = 1;
  static DELETE_FAILED = 2;

  @Prop()
  user!: User;

  loading: boolean = false;
  open: boolean = false;

  toggleOpen() {
    this.open = !this.open;
  }

  deleteUser() {
    if (this.user) {
      this.loading = true;
      userService
        .delete(this.user)
        .then(response => {
          this.open = false;
          messageService.addMessage({
            id: DeleteAccountDialog.DELETE_SUCCESSFUL,
            type: "success",
            text:
              "Se ha cerrado su cuenta. Si desea abrir otra, contáctese con el administrador de la plataforma.",
            overrides: true
          });
          session.logout();
        })
        .catch(response => {
          this.loading = false;
          this.open = false;
          messageService.addMessage({
            id: DeleteAccountDialog.DELETE_FAILED,
            type: "error",
            text: "No se ha podido cerrar la cuenta. Intenta más tarde.",
            overrides: true
          });
        });
    }
  }
}
